// extracted by mini-css-extract-plugin
export default {"section":"AllContacts_section__D9qkF"};